import { logActivity, RESOURCE_TYPES } from '../../utils/activityLogger';

// One action type for every phone-shell interaction; `control` in metadata
// says which. The backend accepts any actionType string, so the shared
// taxonomy files stay untouched.
const ACTION_TYPE = 'practice_control';

export function logPracticeControl({ user, fileName, control, metadata = {}, ui = 'mobile_shell' }) {
  logActivity({
    user,
    actionType: ACTION_TYPE,
    resourceType: RESOURCE_TYPES.MUSICXML,
    resourceId: fileName || null,
    description: `Practice (${ui}): ${control}`,
    metadata: { ui, control, ...metadata }
  });
}

// Coalesces rapid repeats (slider drags, zoom taps) into one log entry
// carrying the first `from` and the last `to` value.
export function createDebouncedLogger(delayMs) {
  let timer = null;
  let first = null;
  return (args, from, to) => {
    if (first === null) first = from;
    clearTimeout(timer);
    timer = setTimeout(() => {
      logPracticeControl({ ...args, metadata: { ...(args.metadata || {}), from: first, to } });
      first = null;
    }, delayMs);
  };
}
